module.exports = __webpack_public_path__ + "img/mw.8cf054ae.png";